import { cn } from "@/lib/utils/utils"
import { VariantProps, cva } from "class-variance-authority"
import { ElementType } from "react"

const iconVariants = cva("", {
  variants: {
    size: {
      sm: "h-4 w-4",
      md: "h-6 w-6",
      lg: "h-8 w-8",
      xl: "h-10 w-10",
    },
    variant: {
      default: "text-neutral-500",
      muted: "text-muted-foreground",
      primary: "text-primary",
      secondary: "text-secondary",
      destructive: "text-destructive",
      success: "text-green-500",
      warning: "text-yellow-500",
    },
  },
  defaultVariants: {
    size: "md",
    variant: "default",
  },
})

interface IconProps extends VariantProps<typeof iconVariants> {
  icon: ElementType
  className?: string
}

function Icon({ icon: Icon, size, variant, className }: IconProps) {
  return <Icon className={cn(iconVariants({ size, variant }), className)} />
}

export { Icon, iconVariants }
